module.exports = __webpack_public_path__ + "5a51ab0e59762e4a3da69663a8fe0d0e.svg";